'use client';

export default function CloseSidemenu() {  
    
    const handleClick = () => {
        if (typeof window !== "undefined") {
            localStorage.setItem("ismenuOpen",'false');
            window.dispatchEvent(new Event("sidemenuToggle"));
        }
      };
    
    return(        
        <button className="clss" type="button" onClick={handleClick}> <i className="fal fa-times"></i> </button>
    )  
};

